import { IPortfolioRegion } from '@api'
import { get } from 'lodash'
import { LocationTreeNodeT } from './forEachNode'
import { LocationNodeType } from '../../components/LocationGroupTrees/components/renderTreeContents'

type MapLocationTreeContents = (
  regions: IPortfolioRegion[],
  allExpanded?: boolean
) => LocationTreeNodeT[]

const mapLocationTreeContents: MapLocationTreeContents = (regions, allExpanded = false) =>
  regions.map<LocationTreeNodeT>((region, regionIndex) => {
    const nodePath: number[] = [regionIndex]

    return {
      id: `${region.id}-${regionIndex}`,
      hasCaret: false,
      label: region.name,
      isExpanded: true,
      isSelected: false,
      className: 'location-tree',
      nodeData: {
        nodePath: [...nodePath].slice(0, 1),
        nodeType: LocationNodeType.Location,
      },
      childNodes: region.cities.map((city, cityIndex) => {
        nodePath[1] = cityIndex

        return {
          id: `${city.id}-${cityIndex}`,
          label: city.name,
          isExpanded: allExpanded,
          isSelected: false,
          nodeData: {
            nodePath: [...nodePath].slice(0, 2),
            nodeType: LocationNodeType.City,
            city: {
              state: get(city, 'buildings[0].state'),
              name: city.name,
            },
          },
          childNodes: city.buildings?.map((building, buildingsIndex) => {
            nodePath[2] = buildingsIndex

            return {
              id: building.id,
              label: building.name,
              isSelected: false,
              isExpanded: allExpanded,
              nodeData: {
                nodePath: [...nodePath].splice(0, 3),
                nodeType: LocationNodeType.Building,
                building: {
                  name: building.name,
                  address: building.address,
                  city: building.city,
                  state: building.state,
                },
              },
              childNodes: building?.floors?.map((floor, floorIndex) => {
                nodePath[3] = floorIndex
                return {
                  id: floor.id,
                  isSelected: false,
                  isExpanded: false,
                  hasCaret: false,
                  label: floor.name,
                  nodeData: {
                    floor,
                    nodePath: [...nodePath],
                    nodeType: LocationNodeType.Floor,
                  },
                }
              }),
            }
          }),
        }
      }),
    }
  })

export default mapLocationTreeContents
